import { useFetch, fmtDate } from "@/lib/shieldx";
import { PageHeader, Loader, Panel, Stat } from "@/components/shieldx/Primitives";
import { RiskBadge, StatusBadge, DemoTag } from "@/components/shieldx/Badges";
import { FileBarChart, Download } from "lucide-react";
import { toast } from "sonner";

export default function Reports() {
  const { data, loading } = useFetch("/reports/summary");
  if (loading || !data) return <Loader label="Compiling reports" />;

  const exportJson = () => {
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `shieldx-report-${Date.now()}.json`; a.click();
    URL.revokeObjectURL(url);
    toast.success("Report exported");
  };

  return (
    <div>
      <PageHeader icon={FileBarChart} title="Reports"
        subtitle={`Executive & compliance summary. Generated ${fmtDate(data.generated_at)}.`}
        actions={
          <button onClick={exportJson} data-testid="export-report" className="flex items-center gap-2 rounded-lg border border-slate-700 bg-slate-900/60 px-4 py-2 text-sm font-semibold text-slate-200 hover:bg-slate-800">
            <Download className="h-4 w-4" /> Export JSON
          </button>
        } />
      <DemoTag />

      <div className="mt-4 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
        {Object.entries(data.counts).map(([k, v]) => (
          <Stat key={k} label={k.replace(/_/g, " ")} value={v} tone="slate" />
        ))}
      </div>

      <div className="mt-4 grid gap-4 lg:grid-cols-3">
        <Panel title="Incidents by Risk">
          <div className="space-y-2">
            {Object.entries(data.incidents_by_risk).map(([k, v]) => (
              <div key={k} className="flex items-center justify-between rounded-lg border border-slate-800 bg-slate-900/60 px-3 py-2">
                <RiskBadge value={k} /><span className="font-mono tabular-nums text-slate-200">{v}</span>
              </div>
            ))}
          </div>
        </Panel>
        <Panel title="Assets by State" className="lg:col-span-2">
          <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
            {Object.entries(data.assets_by_state).map(([k, v]) => (
              <div key={k} className="rounded-lg border border-slate-800 bg-slate-900/60 p-3">
                <StatusBadge value={k} />
                <p className="mt-2 font-display text-xl font-bold tabular-nums text-slate-100">{v}</p>
              </div>
            ))}
          </div>
        </Panel>
      </div>

      <div className="mt-4 grid grid-cols-2 gap-4">
        <Stat label="Integrations Connected" value={data.integrations_connected} tone="emerald" />
        <Stat label="Integrations Pending / Untrusted" value={data.integrations_pending} tone="amber" />
      </div>
    </div>
  );
}
